import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { theme } from '../styles/GlobalStyle';
import CarregandoDna from './ui/CarregandoDna';

interface LoadingSpinnerProps {
  size?: 'small' | 'medium' | 'large';
  message?: string;
  fullScreen?: boolean;
}

/*
 * A espera do portal inteiro é a dupla hélice (10/10, pedido do Valdair: "o load era para ser global").
 * Antes era um círculo; a hélice só existia na carga da ficha. Toda espera de tela cheia (login, conferência
 * do acesso, o pedaço da página que o navegador ainda baixa) e as esperas dentro das telas passam por aqui.
 *
 * Tela cheia: o palco cobre a janela inteira (menu e cabeçalho ainda não existem nessa hora), então a hélice fica
 * no centro da janela. Antes ela descontava um menu que não estava desenhado e aparecia 115 px à direita com o menu
 * aberto (34 px recolhido) e 18 px abaixo no celular (11/10, "tem que ficar centralizado no espaço em branco").
 * Quando o layout chega com o menu, a espera da ficha (AdminLayout centralizado) centraliza no espaço que sobra.
 * Na ficha do paciente ela vem com o nome da Essentia, como na carga da ficha.
 */
const naFichaDoPaciente = () =>
  typeof window !== 'undefined' && /^\/admin\/patients\/[^/]+/.test(window.location.pathname);

const Palco = styled.div`
  position: fixed; inset: 0; z-index: 9999; box-sizing: border-box;
  display: flex; flex-direction: column; align-items: center; justify-content: center;
  padding: ${theme.spacing.lg} ${theme.spacing.md};
  background: ${theme.colors.background};
`;

const NoMeio = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${theme.spacing.lg};
`;

const alturaDaHelice = { small: 48, medium: 72, large: 96 };

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'medium',
  message,
  fullScreen = false,
}) => {
  const { i18n } = useTranslation();
  if (fullScreen) {
    const ficha = naFichaDoPaciente();
    return (
      <Palco>
        <CarregandoDna
          titulo={ficha ? 'Essentia' : undefined}
          mensagem={ficha
            ? (i18n.language === 'pt' ? 'Preparando inteligência clínica…' : 'Preparing clinical intelligence…')
            : message}
        />
      </Palco>
    );
  }
  return (
    <NoMeio>
      <CarregandoDna tamanho={alturaDaHelice[size]} mensagem={message} />
    </NoMeio>
  );
};

export default LoadingSpinner;
